import { MainContainer } from "@/appComponents/Blocks/Utils/MainContainer";
import Header from "@/appComponents/Navigation/Header/Header";
import MainToolbarPlanningTabular from "@/appComponents/Navigation/MainToolbar/planning/MainToolbarPlanningTabular";
import { DataTable, Loader } from "@theorgchartdev/storybook";
import {
  usePlanningTabularContext,
  useTableInstanceContext
} from "@/providers/PlanningTabularProvider";
import { useModalContainerHeight } from "@/hooks/useModalContainerHeight";
import { appstr } from "@coreapp/utils/appstr";
import PlanApprovalStatusAlert from "@/appComponents/Blocks/ChartAlerts/PlanApprovalStatusAlert/PlanApprovalStatusAlert";
import PlanStatusAlert from "@/appComponents/Blocks/ChartAlerts/PlanStatusAlert/PlanStatusAlert";
import { usePlanManagerContext } from "@/providers/PlanManagerProvider";

const PlanningTabularPage = () => {
  const { isFetching, isSearchLoading, tableRef } = usePlanningTabularContext();
  const { selectedPositionsCount } = useTableInstanceContext();
  const { isApprovalAlertDismissed, isPlanStatusAlertDismissed } = usePlanManagerContext();

  const containerHeight = useModalContainerHeight([
    isApprovalAlertDismissed,
    isPlanStatusAlertDismissed
  ]);

  const showLoader = isFetching || isSearchLoading;

  return (
    <>
      <div className="appHeader">
        <Header />
        <div className="mainToolBar">
          <MainToolbarPlanningTabular />
        </div>
        <PlanApprovalStatusAlert />
        <PlanStatusAlert />
      </div>
      <MainContainer>
        <Loader.Root asChild>
          <div
            data-testid="planning-table-container"
            className="oc-table-container"
            style={{ height: containerHeight }}
          >
            <DataTable.Root ref={tableRef}>
              <DataTable.Header />
              <DataTable.Body />
            </DataTable.Root>
            <DataTable.Pagination
              pageSizeOptions={[25, 50, 100]}
              selectedRowsCount={selectedPositionsCount}
            />
            {showLoader && (
              <Loader.Container>
                <Loader.Spinner />
                <Loader.Text>{appstr("Loading")}</Loader.Text>
              </Loader.Container>
            )}
          </div>
        </Loader.Root>
      </MainContainer>
    </>
  );
};

export default PlanningTabularPage;
